const appEnv = process.env.REACT_APP_ENV || "development";

interface Environment {
  apiUrl: string;
}

interface Environments {
  [key: string]: Environment;
}

export const environments: Environments = {
  development: {
    apiUrl: process.env.REACT_APP_API || "http://localhost:3000/v1",
  },
  test: {
    apiUrl: process.env.REACT_APP_API || "https://api.visionmediax.dev/v1",
  },
  staging: {
    apiUrl: process.env.REACT_APP_API || "https://api.clicksua.dev/v1",
  },
  production: {
    apiUrl: process.env.REACT_APP_API as string,
  },
};

export const appEnvironment: Environment = environments[appEnv];
